import React from "react";

export default function Close() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M11.9996 10.5858L18.3635 4.22183L19.7777 5.63604L13.4138 12L19.7777 18.364L18.3635 19.7782L11.9996 13.4142L5.6356 19.7782L4.22138 18.364L10.5853 12L4.22138 5.63604L5.6356 4.22183L11.9996 10.5858Z" fill="black" />
        </svg>
    );
}